module.exports = __webpack_public_path__ + "components/MapControl/svg/Inny obiekt historyczny.svg?13c2fef4";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Inny obiekt historyczny.svg
// module id = 2037
// module chunks = 0